import { Form, FieldAnswer, LogicJumpActionType } from '@app/api';

export const getNextLogicPage = (
  form: Form,
  page: number,
  fieldAnswer?: FieldAnswer,
): number => {
  const fields = form.fields || [];
  const defaultNextFieldIndex = page + 1;

  if (!fieldAnswer) {
    return defaultNextFieldIndex;
  }

  const field = fields.find((f) => f.id === fieldAnswer.field.id);
  const logicJumpForFieldAnswer = field?.jumpActions;

  if (!logicJumpForFieldAnswer) {
    return defaultNextFieldIndex;
  }

  let jumpAction = logicJumpForFieldAnswer.find((jumpAction) =>
    jumpAction.conditionChoiceRefs?.some((ref) => {
      const fieldAnswerChoicesRef = fieldAnswer.choices?.refs
        ? fieldAnswer.choices.refs
        : fieldAnswer.choice?.ref
        ? [fieldAnswer?.choice?.ref]
        : [];

      return fieldAnswerChoicesRef.includes(ref);
    }),
  );

  if (!jumpAction) {
    jumpAction = logicJumpForFieldAnswer.find(
      (jumpAction) => !jumpAction.conditionChoiceRefs,
    );
  }

  if (!jumpAction || jumpAction.type === LogicJumpActionType.NEXT_QUESTION) {
    return defaultNextFieldIndex;
  }

  if (jumpAction.type === LogicJumpActionType.END_FORM) {
    return form.fieldIds.length;
  }

  if (jumpAction.type === LogicJumpActionType.JUMP) {
    const nextFieldIndexForFieldAnswer = fields.findIndex(
      (field) => field.id === jumpAction?.toFieldId,
    );

    if (nextFieldIndexForFieldAnswer !== -1) {
      return nextFieldIndexForFieldAnswer;
    }
  }
  return defaultNextFieldIndex;
};
